module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/fluent-app-icon-8.e3fd81f3.png";